var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/storage",
    clipPath: "url(#clip0_1443_695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4528 9.00039H15.4758C15.3512 6.92585 14.4708 4.96885 13.0011 3.49937C11.5315 2.02989 9.57438 1.14977 7.49982 1.02539V5.05139C8.50846 5.16491 9.44872 5.61735 10.1668 6.3347C10.8849 7.05206 11.3383 7.99187 11.4528 9.00039Z",
    stroke: "#6A82D2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.99983 3.31439C3.94131 3.65728 2.98853 4.26616 2.23272 5.08273C1.4769 5.89929 0.943353 6.89621 0.683156 7.97803C0.422959 9.05985 0.444824 10.1904 0.746659 11.2613C1.04849 12.3323 1.62019 13.3078 2.40702 14.0945C3.19384 14.8813 4.16945 15.4528 5.24044 15.7545C6.31143 16.0562 7.44193 16.078 8.52372 15.8176C9.60551 15.5573 10.6024 15.0236 11.4188 14.2677C12.2353 13.5118 12.8441 12.559 13.1868 11.5004",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7 11C7.82843 11 8.5 10.3284 8.5 9.5C8.5 8.67157 7.82843 8 7 8C6.17157 8 5.5 8.67157 5.5 9.5C5.5 10.3284 6.17157 11 7 11Z",
    stroke: "#454C58",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1443_695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.5c2997e75e897c688e954af5eb04fbba.svg";
export { ForwardRef as ReactComponent };